"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionValidationMiddlewareFactory = void 0;
const SportradarEnforcerFactory_1 = require("../Factories/SportradarEnforcerFactory");
const index_1 = require("../index");
class ActionValidationMiddlewareFactory {
    static async fromProxyEvent(event) {
        const enforcerFactory = new SportradarEnforcerFactory_1.SportradarEnforcerFactory();
        const enforcer = await enforcerFactory.createFromProxyEvent(event);
        return new index_1.ActionValidationMiddleware(enforcer);
    }
    static async fromMarketingCloudUser(user) {
        const enforcerFactory = new SportradarEnforcerFactory_1.SportradarEnforcerFactory();
        const enforcer = await enforcerFactory.createFromMarketingCloudUser(user);
        return new index_1.ActionValidationMiddleware(enforcer);
    }
}
exports.ActionValidationMiddlewareFactory = ActionValidationMiddlewareFactory;
//# sourceMappingURL=ActionValidationMiddlewareFactory.js.map